import React from "react";
import "../Styles/Styles.css";
import { FaCheckCircle } from "react-icons/fa";

import onGrid from "../../Asserts/on-grid.png"
import offGrid from "../../Asserts/off-grid.png";
import hybrid from "../../Asserts/hybrid.png";
import streetLight from "../../Asserts/solar-street-light.png";
import evCharging from "../../Asserts/ev-charging.png";
import assetMgmt from "../../Asserts/asset-management.png";

const solutions = [
  {
    title: "ON GRID SYSTEM",
    image: onGrid,
    description:
      "Directly connected to the utility grid. No battery backup. Exports excess power.",
  },
  {
    title: "OFF GRID SYSTEM",
    image: offGrid,
    description:
      "Independent from the utility grid. Relies entirely on battery storage.",
  },
  {
    title: "HYBRID SYSTEM",
    image: hybrid,
    description:
      "Connected to grid with battery backup. The most versatile solution.",
  },
  {
    title: "SOLAR STREET LIGHT",
    image: streetLight,
    description:
      "All-in-One Solar Street Lighting Solutions. No trenching or grid connection required, leading to fast deployment. Stores energy for night operation.",
  },
  {
    title: "EV CHARGING INFRASTRUCTURE",
    image: evCharging,
    description: (
      <>
        End-to-end design, installation, and management of public, commercial,
        and fleet EV charging hubs.
        <ul>
          <li><FaCheckCircle className="list-check-icon" /> AC & DC Charger Installation</li>
          <li><FaCheckCircle className="list-check-icon" /> Load Management & Grid Integration</li>
          <li><FaCheckCircle className="list-check-icon" /> Solar Integration for Green Charging</li>
        </ul>
      </>
    ),
  },
  {
    title: "ASSET MANAGEMENT SYSTEM",
    image: assetMgmt,
    description: (
      <>
        Proactive maintenance and life-cycle management for all electrical and
        solar assets.
        <ul>
          <li><FaCheckCircle className="list-check-icon" /> Preventive & Predictive Maintenance (O&M)</li>
          <li><FaCheckCircle className="list-check-icon" /> Real-time Monitoring and Diagnostics</li>
          <li><FaCheckCircle className="list-check-icon" /> Digital Twin & Documentation Management</li>
        </ul>
      </>
    ),
  },
];

const Solutions = () => {
  return (
    <section className="solutions-container">
      <div className="solutions-grid">
        {solutions.map((item, index) => (
          <div key={index} className="solution-card">
            <h3>{item.title}</h3>

            <div className="solution-image">
              <img src={item.image} alt={item.title} />
            </div>

            <div className="solution-desc">{item.description}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Solutions;
